/**
 * English locale. Reading scripts target diverse phonetic coverage.
 *
 * @graph-stack voice-enrollment
 * @graph-domain Engineering
 * @graph-business 英語 UI 文言と読み上げスクリプト 3 文の locale bundle
 * @graph-connects none
 */

import type { LocaleBundle } from './types.js';

/** @graph-connects none */
export const en: LocaleBundle = {
  messages: {
    appTitle: 'Voice Enrollment',
    consent: {
      title: 'Consent',
      summary:
        'Voice enrollment improves speaker identification for Meet recordings. Please review the data handling below before proceeding.',
      items: [
        'Recorded audio is used only to compute voice fingerprints (embeddings).',
        'Original audio is auto-deleted from GCS after 30 days. Voice fingerprints are retained until you request deletion.',
        'You can request deletion of your voice data at any time.',
        'Data stays internal — only the in-house speaker identification pipeline accesses it.',
      ],
      agreeLabel: 'Agree and continue',
      declineLabel: 'Cancel',
    },
    languageSelect: {
      title: 'Pick a language',
      description:
        'We enroll a voice fingerprint per primary meeting language. You can come back later to add more languages.',
      languageNames: {
        ja: '日本語',
        en: 'English',
        vi: 'Tiếng Việt',
      },
      confirm: 'Next',
    },
    recording: {
      title: 'Record reading samples',
      instruction:
        'Read the displayed sentence in your natural voice. Find a quiet place and stay within 30 cm of the microphone.',
      progressLabel: 'Recording…',
      startLabel: 'Start recording',
      stopLabel: 'Stop recording',
      retakeLabel: 'Retake',
      nextLabel: 'Next sentence',
      submitLabel: 'Enroll',
      qualityIssue: 'Audio quality issue detected',
      qualityHint:
        'The recording may be too short, too quiet, or contain too much silence. Please try again.',
      recordHint: 'Tap to record',
      checkHint: 'Tap to check',
      readyHint: '✓ Ready',
      retryHint: '⚠ Retry',
    },
    result: {
      successTitle: 'Enrollment complete',
      successDescription:
        'Your speech in Meet recordings will now be attributed to you by name in transcripts.',
      failureTitle: 'Enrollment failed',
      failureDescription:
        'A server error occurred. Please try again in a few minutes. Contact an administrator if the problem persists.',
      backLabel: 'Start over',
    },
  },
  readingScripts: [
    {
      id: 'en-1',
      text: 'On a bright Saturday afternoon, I sipped an iced matcha latte by the harbor while sketching new outfit ideas in a notebook with a turquoise cover.',
      estimatedSeconds: 12,
    },
    {
      id: 'en-2',
      text: 'My favorite weekend ritual is hunting for vintage denim, baking sourdough loaves, and walking my chocolate labrador through the park.',
      estimatedSeconds: 11,
    },
    {
      id: 'en-3',
      text: 'Last summer I traveled to Lisbon, climbed the colorful hills, and tasted custard tarts that were warm, crispy, and dusted with cinnamon.',
      estimatedSeconds: 11,
    },
  ],
};
